module.exports = __webpack_public_path__ + "static/img/Platinum2.deb7e8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Platinum2.svg
// module id = N9n6
// module chunks = 35